var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef } from "react";
import usePrevious from "react-use/lib/usePrevious";
import Flex from "../templates/flex";
import useIntersection from "../../hooks/use-intersection";
import setParentRef from "../../mixins/set-ref";
var getContent = function (value) { return (typeof value === "function" ? value() : value); };
var Intersection = forwardRef(function (_a, parentRef) {
    var _b = _a.height, height = _b === void 0 ? "100%" : _b, _c = _a.width, width = _c === void 0 ? "100%" : _c, _d = _a.fallback, fallback = _d === void 0 ? null : _d, root = _a.root, _e = _a.rootMargin, rootMargin = _e === void 0 ? "0px" : _e, _f = _a.threshold, threshold = _f === void 0 ? 0 : _f, onVisibility = _a.onVisibility, children = _a.children, rest = __rest(_a, ["height", "width", "fallback", "root", "rootMargin", "threshold", "onVisibility", "children"]);
    var _g = useIntersection({ root: root, rootMargin: rootMargin, threshold: threshold, onVisibility: onVisibility }), setRef = _g[0], ref = _g[1], visible = _g[2];
    var prevVisible = usePrevious(visible);
    var lastHeightRef = useRef(height);
    if (visible !== prevVisible && !visible && ref.current) {
        lastHeightRef.current = "".concat(ref.current.clientHeight, "px");
    }
    return (React.createElement(Flex, __assign({ ref: function (element) {
            setRef(element);
            setParentRef(parentRef, element);
        }, width: width }, { height: visible ? height : { min: lastHeightRef.current } }, rest), getContent(visible ? children : fallback)));
});
export default Intersection;
